import React from 'react';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import { useNavigate, useLocation } from 'react-router-dom';

const BackButton = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const goBack = () => {
      // console.log(location.pathname);
        navigate(-1, false);
        // window.history.back();
        // Navigation.goBack();
      };

      return (
        <div onClick={goBack}>          
          <ArrowCircleLeftIcon variant="contained" sx={{color:'blue'}} onClick={goBack} />
        </div>
      );
}

export default BackButton